var Constructor = require('js/vendor/constructor');
var Backbone = require('backbone');
var _ = require('underscore');
var Amanda = require('js/vendor/amanda');
var Api = require('js/api');
var Promise = require('js/vendor/promise');
var validationMessages = require('js/validationMessages');
var DataCache = require('js/mixins/dataCache');
var SyncCount = require('js/mixins/syncCount');

var Model = Constructor.extendFrom(Backbone.Model).mixes(DataCache, SyncCount);


/**
 * Store API required params to fetch. Their presence will be checked prior
 * to issue a fetch request to the API
 * @type {Object}
 */
Model.prototype.requiredParams = [];


/**
 * Store model options
 * @type {Object}
 */
Model.prototype.options = {};


/**
 * Store descriptive data
 */
Model.prototype.description = {};


/**
 * Data cache map
 * @type {{}}
 */
Model.prototype.dataCacheMap = {};


/**
 * Initialize our model
 */
Model.prototype.initialize = function(attributes, options) {
  // Override options ref while merging defaults with user options
  this.options = _.extend({}, this.options, options);

  // Initial description
  this.description = this.options.description || {};

  // Initialize our data cache
  this.initializeDataCache({}, this.dataCacheMap);
};


/**
 * Model validation method
 * @param attrs
 * @returns {*}
 */
Model.prototype.validate = function(attrs) {

  // Initialize a JSON Schema validator.
  // schema should be defined as described at https://github.com/Baggz/Amanda/blob/master/docs/json/objects/schema.md
  if (this.schema) {
    var result = null;
    var jsonSchemaValidator = Amanda('json');

    // Validate the model attributes against the schema.
    // This assumes we only ever use synchronous validations
    jsonSchemaValidator.validate(attrs, this.schema, {
      singleError: false,
      messages: validationMessages
    }, function(error) {
      result = error;
    });

    //Returns the error object if any
    if (result) {
      return result;
    }
  }
};


/**
 * Override sync so we can use our own logic
 * @return {Request} Request object (promise)
 */
Model.prototype.sync = function() {
  return Api.sync.apply(this, arguments);
};


/**
 * Default fallback model parsing
 */
Model.prototype.parse = function(response) {
  // Ensure data cache
  this.ensureDataCache(response, this.dataCacheMap);

  return response;
};


/**
 * Wrap fetch method so it always returns a promise
 * @return {Promise} Promise for fetch action
 */
Model.prototype.fetch = function(options) {
  // Extend options with defaults
  options = _.extend({}, this.options, options);

  //Check for required parameters before fetch
  this.requiredParams.map(function(value) {
    if (!options.data[value] && !this.description[value]) {
      throw new Error('Model ' + value + ' parameter is mandatory to fetch');
    }
  }, this);

  // Call super
  var fetch = Model.__super__.fetch.call(this, options);

  // Ensure promise is returned
  return fetch ? fetch : Promise.broken(new Error('Fetch method rejected.'));
};

/**
 * Wrap save method so it always returns a promise
 * @return {Promise} Promise for save action
 */
Model.prototype.save = function(key, val, options) {
  var attrs;

  // Handle both `"key", value` and `{key: value}` -style arguments.
  if (key == null || typeof key === 'object') {
    attrs = key;
    options = val;
  } else {
    (attrs = {})[key] = val;
  }

  // Extend options with defaults
  options = _.extend({}, this.options, options);

  // Call super
  var save = Model.__super__.save.call(this, attrs, options);

  // Ensure promise is returned
  return save ? save : Promise.broken(new Error('Save method rejected. Could be that validation failed?'));
};


/**
 * Wrap destroy method so it always returns a promise
 * @return {Promise} Promise for destroy action
 */
Model.prototype.destroy = function(options) {
  // Extend options with defaults
  options = _.extend({}, this.options, options);

  //Check for required parameters before save
  this.requiredParams.map(function(value) {
    if ((options.data && !options.data[value]) && !this.description[value]) {
      throw new Error('Model ' + value + ' parameter is mandatory to destroy');
    }
  }, this);

  // Call super
  var destroy = Model.__super__.destroy.apply(this, arguments);

  // Ensure promise is returned
  return destroy ? destroy : Promise.broken(new Error('Destroy method rejected.'));
};


/**
 * Set data which describes the resource we are dealing with (gets sent with requests)
 * Pass true as the third parameter to also set the model attribute
 * @return {this} for chaining
 */
Model.prototype.desc = function(key, value, doSet) {
  this.description[key] = value;

  if (doSet) {
    this.set(key, value);
  }

  // Return this for chaining
  return this;
};


/**
 * Clear descriptive data using given key
 */
Model.prototype.clearDesc = function(key) {
  if (key) {
    delete this.description[key];
  } else {
    this.description = {};
  }

  // Return this for chaining
  return this;
};


/**
 * Return an attached collection as a potential parent for data cache
 */
Model.prototype.getDataCacheParent = function() {
  return this.collection || null;
};


module.exports = Model;



// WEBPACK FOOTER //
// ./app/assets/js/lib/model.js